import styled from "styled-components";

export const TestimonialContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #212121;
  background: radial-gradient(
    circle farthest-corner at 18.5% 28.5%,
    #203a43 0,
    #0f1b27 91%
  );
`;

export const TestimonialWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  align-items: center;
  width: 90%;
  .rec.rec-dot.rec.rec-dot_active {
    background: #79c500;
    box-shadow: 0 0 1px 3px #79c500;
  }
  .rec.rec-arrow {
    border-radius: 0;
  }
  /* round buttons on hover */
  .rec.rec-arrow:hover {
    border-radius: 50%;
  }
  /* hide disabled buttons */
  .rec.rec-arrow:disabled {
    visibility: hidden;
  }
  /* disable default outline on focused items */
  /* add custom outline on focused items */
  .rec-carousel-item:focus {
    outline: none;
    box-shadow: inset 0 0 1px 1px lightgrey;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    .rec.rec-arrow {
      display: none;
    }
  }
`;

export const TestimonialH1 = styled.h1`
  color: #f7f8fa;
  text-align: center;
  padding: 2rem 0.5rem 2rem 0.5rem;
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;
